import { TOOL_ACTION } from 'store/selectors/toolSelector';

/* -------------------------------------------------------------
 * 1. TOOL MODE HANDLERS
 * ------------------------------------------------------------- */

export type ToolModeHandlers = {
	done?: () => void;
	cancel?: () => void;

	doneConfirmMessage?: string;
	cancelConfirmMessage?: string;
	doneConfig?: React.ButtonHTMLAttributes<HTMLButtonElement> & { tooltipContent?: string };

};

const toolModeRegistry = {} as Record<TOOL_ACTION, ToolModeHandlers>;

export function registerToolModeHandlers(
	mode: TOOL_ACTION,
	handlers: ToolModeHandlers
) {
	toolModeRegistry[mode] = handlers;
}

export function getToolModeHandlers(
	mode: TOOL_ACTION
): ToolModeHandlers | undefined {
	return toolModeRegistry[mode];
}

export function clearToolModeHandlers(mode: TOOL_ACTION) {
	delete toolModeRegistry[mode];
}

/* -------------------------------------------------------------
 * 2. DIRECT ACTION HANDLERS 
	(eg: CHANGE ORIENTATION, REMOVE SHADING, RECALCUTE LAYOUT etc..)
 * ------------------------------------------------------------- */

export type ActionHandler = () => void;

const actionRegistry = {} as Record<string, ActionHandler>;

export function registerActionHandler(
	actionName: string,
	handler: ActionHandler
) {
	actionRegistry[actionName] = handler;
}

export function getActionHandler(actionName: string): ActionHandler | undefined {
	return actionRegistry[actionName];
}

export function clearAction(actionName: string) {
	delete actionRegistry[actionName];
}

